// extracted by css-extract-rspack-plugin
export default {"LabelTokenDecorator":"label-token-module__LabelTokenDecorator__IndHN"};